import styled from 'styled-components';

export const Container = styled.div`
  display: inline-block;
  background-color: ${(props) => props.background};
  border-radius: 4px;
  border: 1px solid ${(props) => props.borderColor};
  width: ${(props) => (props.width ? props.width : 'fit-content')};
`;
